import styled from 'styled-components'
import L from '../L'

const StyledSearch = styled(L).attrs({
  pX: {
    xx: 0,
    lg: 1.5,
  },
})`
  transition: ${props => props.theme.mixins.transition(['padding-left', 'padding-right'])};
`

const StyledTabHeader = styled(L).attrs({
  bgColor: 'paper',
  position: 'relative',
})`
    max-width: 100vw;
    overflow-x: hidden;
    box-shadow: ${props => props.theme.globals.boxShadowSmaller};
  
    // TABS
    & > div > div:first-of-type {
      width: 100%;
  
      ${props =>
        props.animationState === 'turn-on' || props.animationState === 'set-on'
          ? `
        transition: opacity .2s ease-in-out, width 0s .2s ease-in-out;
      `
          : `
        transition: opacity .2s .9s ease-in-out, width 0s .9s ease-in-out;
      `}
  
      // & *:not(svg) {
      //   height: 100%;
      // }
    }
    // MENU
    & > div > div:last-of-type {
      width: 100%;
  
      & > div {
        ${props => props.theme.mixins.mX(1.5)}
        ${props =>
          props.theme.mixins.mq(
            `
          margin-right: 0;
        `,
            'md',
            'lg',
          )}
        ${props =>
          props.theme.mixins.mq(
            `
          margin-left: 0;
        `,
            'lg',
          )}
      }
      ${props =>
        props.animationState === 'turn-on' || props.animationState === 'set-on'
          ? `
        transition: opacity .2s ease-in-out, width 0s .5s ease-in-out;
      `
          : `
        transition: opacity .2s .9s ease-in-out, width 0s .2s ease-in-out;
      `}
  
    }
  
    ${props =>
      props.animationState === 'turn-on' || props.animationState === 'set-on'
        ? `
      & > div > div:first-of-type {
        opacity: 0;
        width: 0;
      }
      & > div > div:last-of-type {
        opacity: 0;
        width: 0;
      }
    `
        : `
    
    `}
  
  `

export { StyledSearch, StyledTabHeader }
